<script>
import { mapGetters } from 'vuex';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import RbxTextEditor from '@/shared/reybex/RbxTextEditor';
import RbxDatePicker from '@/shared/reybex/RbxDatePicker';
import fieldVisibilityMixin from '@/mixins/fieldVisibility';

export default {
  name: 'EmployeeBasicInfoForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxTextEditor,
    RbxDatePicker,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'employee',
    };
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    changeValidFromDate(newDate) {
      this.employee.validFrom = newDate;
    },
    changeValidUntilDate(newDate) {
      this.employee.validUntil = newDate;
    },
  },
};
</script>

<template>
  <v-layout row wrap>
    <!-- Basic information left column -->
    <v-flex md8 xs12>

      <h4 class="employee-detail-tab-title">Stammdaten</h4>
      <v-layout row wrap>
        <v-flex v-if="isFieldVisible('employee.salutation')" md4 py-0>
          <rbx-remote-combobox
            v-model="employee.salutation"
            label="Anrede"
            :selected="employee.salutation"
            domain="salutation"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.firstname')" md4 py-0>
          <v-text-field
            v-model="employee.firstname"
            label="Vorname"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.surname')" md4 py-0>
          <v-text-field
            v-model="employee.surname"
            label="Nachname"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.phone')" md4 py-0>
          <v-text-field
            v-model="employee.phone"
            label="Telefon"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.mobile')" md4 py-0>
          <v-text-field
            v-model="employee.mobile"
            label="Handy"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.email')" md4 py-0>
          <v-text-field
            v-model="employee.email"
            label="E-Mail-Adresse"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.department')" md4 py-0>
          <rbx-remote-combobox
            v-model="employee.department"
            label="Abteilung"
            :selected="employee.department"
            domain="department"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.validFrom')" md4 py-0>
          <rbx-date-picker
            label="Eintrittsdatum" :value="employee.validFrom" @input="changeValidFromDate"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.validUntil')" md4 py-0>
          <rbx-date-picker
            label="Austrittsdatum" :value="employee.validUntil" @input="changeValidUntilDate"
          />
        </v-flex>

        <v-flex xs12 md12 v-if="isFieldVisible('employee.comment')">
          <rbx-text-editor
            label="Notiz"
            v-model="employee.comment"
          />
        </v-flex>
      </v-layout>

      <h4 class="employee-detail-tab-title">Administration</h4>
      <v-layout row wrap>

        <v-flex v-if="isFieldVisible('employee.username')" md4 py-0>
          <v-text-field
            v-model="employee.username"
            label="Benutzername"
            height="22"
            class="caption"
          />
        </v-flex>

        <v-flex v-if="isFieldVisible('employee.password')" md4 py-0>
          <v-text-field
            v-model="employee.password"
            label="Neues Passwort"
            height="22"
            class="caption"
            type="password"
          />
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex md2 py-0>
          <v-switch
            v-model="employee.isDelete"
            label="Gelöscht"
            height="0"
            :readonly="!auth.hasDeleteRights"
          />
        </v-flex>

        <v-flex md2 py-0>
          <v-switch
            v-model="employee.enabled"
            label="Aktiv"
            height="0"
          />
        </v-flex>

      </v-layout>
    </v-flex>
  </v-layout>
</template>
